import React from 'react';

export interface IContainerProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

export const Container: React.FC<IContainerProps> = ({
  children,
  onClick,
  disabled = false,
}) => (
  <button
    className="tw-max-w-1/2 tw-lf-button-clear tw-flex tw-h-full tw-w-1/2 tw-flex-1 !tw-grid-cols-[36px_auto] tw-flex-col tw-items-center tw-justify-center tw-gap-y-0.5 tw-overflow-hidden tw-bg-transparent !tw-p-0 tw-text-left disabled:tw-cursor-default desktop:tw-grid desktop:tw-justify-start desktop:!tw-px-2 desktop:tw-grid-template-[picto_title_title|picto_label_label]"
    onClick={onClick}
    type="button"
    disabled={disabled}
  >
    {children}
  </button>
);
